













































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import { storeDokumentasiKelainanKulit } from "@/store/modules/DokumentasiKelainanKulitStore";
import DokumentasiKelainanKulitSvc from "@/services/DokumentasiKelainanKulit";
import BodyMapCanvas from "@/components/perioperatif/BodyMapCanvas.vue";
import { appModule } from "@/store/modules/app";

@Component({
  components: { BodyMapCanvas },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class DokumentasiKelainanKulitInputModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) editData: any;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;
  uploading = false;
  requiredRule = [v => !!v || "*Kolom ini harus diisi"];

  record: any = null;
  fotos: any[] = [];

  previewDialog = false;
  previewUrl = "";

  upload = { view: "overview", catatan: "", file: null as File | null };

  jenisLesiOpts = [
    "Makula", "Papula", "Plak", "Nodul", "Vesikel", "Bula", "Pustula",
    "Urtika", "Erosi", "Ulkus", "Krusta", "Skuama", "Likenifikasi", "Lain-lain"
  ];

  viewOpts = [
    { value: "overview", text: "Overview (jauh)" },
    { value: "close_up", text: "Close-up (dekat)" },
    { value: "dermoscopy", text: "Dermoskopi" },
    { value: "lainnya", text: "Lainnya" }
  ];

  form_data = this.defaultForm();

  defaultForm() {
    const today = localISODate();
    return {
      tanggal_periksa: today,
      dokter_id: null as number | null,
      lokasi_anatomi: "",
      jenis_lesi: null as string | null,
      deskripsi: "",
      diagnosis_kerja: "",
      diagnosis_icd10: "",
      catatan_perkembangan: "",
      body_map_data: [] as any[]
    };
  }

  get dialog() {
    return this.value;
  }
  set dialog(value) {
    this.$emit("input", value);
  }

  get listDokter() {
    return storeDokter.list;
  }

  get storeUser() {
    return userModule.user;
  }

  get currentId() {
    return this.record?.id || null;
  }

  labelView(v: string) {
    const f = this.viewOpts.find(o => o.value === v);
    return f ? f.text : v || "-";
  }

  @Watch("value")
  onDialogOpen(val: boolean) {
    if (!val) return;
    if (this.editData) {
      this.record = this.editData;
      this.fotos = Array.isArray(this.editData.fotos) ? [...this.editData.fotos] : [];
      this.hydrateFromEdit();
    } else {
      this.record = null;
      this.fotos = [];
      this.form_data = this.defaultForm();
      if ((this.storeUser?.profesi || "").toLowerCase() === "dokter") {
        this.form_data.dokter_id = this.storeUser.id;
      }
    }
    this.upload = { view: "overview", catatan: "", file: null };
  }

  hydrateFromEdit() {
    const d = this.editData || {};
    this.form_data = {
      tanggal_periksa: d.tanggal_periksa || localISODate(),
      dokter_id: d.dokter?.id || null,
      lokasi_anatomi: d.lokasi_anatomi || "",
      jenis_lesi: d.jenis_lesi || null,
      deskripsi: d.deskripsi || "",
      diagnosis_kerja: d.diagnosis_kerja || "",
      diagnosis_icd10: d.diagnosis_icd10 || "",
      catatan_perkembangan: d.catatan_perkembangan || "",
      body_map_data: Array.isArray(d.body_map_data) ? d.body_map_data : []
    };
  }

  async buildPayload() {
    let png: string | null = null;
    try {
      png = await (this.$refs.bodyMap as any)?.snapshotPng?.();
    } catch {
      png = null;
    }
    const hasMarker = Array.isArray(this.form_data.body_map_data) && this.form_data.body_map_data.length > 0;
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      tanggal_periksa: this.form_data.tanggal_periksa || null,
      dokter_id: this.form_data.dokter_id,
      lokasi_anatomi: this.form_data.lokasi_anatomi || null,
      jenis_lesi: this.form_data.jenis_lesi || null,
      deskripsi: this.form_data.deskripsi || null,
      diagnosis_kerja: this.form_data.diagnosis_kerja || null,
      diagnosis_icd10: this.form_data.diagnosis_icd10 || null,
      catatan_perkembangan: this.form_data.catatan_perkembangan || null,
      body_map_data: this.form_data.body_map_data || [],
      body_map_png: hasMarker ? png : null
    };
  }

  async save() {
    if (this.readOnly) return;
    const form = this.$refs.form as any;
    if (!form.validate()) return;
    if (this.saving) return;
    this.saving = true;

    try {
      const payload = await this.buildPayload();
      const resp = this.currentId
        ? await DokumentasiKelainanKulitSvc.update(this.currentId, payload)
        : await DokumentasiKelainanKulitSvc.create(payload);

      if (resp.data.status == "1") {
        this.record = resp.data.data;
        this.fotos = Array.isArray(resp.data.data?.fotos) ? resp.data.data.fotos : this.fotos;
        await storeDokumentasiKelainanKulit.getByRegister(this.register);
        this.$emit("saved");
        appModule.NoticeDelay(
          this.fotos.length || this.currentId
            ? "Dokumentasi tersimpan"
            : "Dokumentasi tersimpan — sekarang Anda dapat mengunggah foto klinis"
        );
      }
    } finally {
      this.saving = false;
    }
  }

  onFileChosen(f: File | null) {
    if (f && f.size > 10 * 1024 * 1024) {
      appModule.NoticeDelayAlert("Ukuran file melebihi 10MB");
      this.upload.file = null;
    }
  }

  async onUpload() {
    if (this.readOnly) return;
    if (!this.currentId || !this.upload.file) return;
    this.uploading = true;
    const res = await DokumentasiKelainanKulitSvc.uploadFoto(this.currentId, this.upload.file, {
      view: this.upload.view || undefined,
      catatan: this.upload.catatan || undefined
    });
    this.uploading = false;
    if (res) {
      this.fotos = [...this.fotos, res];
      this.upload.file = null;
      this.upload.catatan = "";
      await storeDokumentasiKelainanKulit.getByRegister(this.register);
      this.$emit("saved");
      appModule.NoticeDelay("Foto berhasil diunggah");
    }
  }

  async onDeleteFoto(f: any) {
    if (this.readOnly) return;
    if (!this.currentId) return;
    if (!confirm("Hapus foto ini?")) return;
    const ok = await DokumentasiKelainanKulitSvc.deleteFoto(this.currentId, f.id);
    if (ok) {
      this.fotos = this.fotos.filter(x => x.id !== f.id);
      await storeDokumentasiKelainanKulit.getByRegister(this.register);
      this.$emit("saved");
      appModule.NoticeDelay("Foto dihapus");
    }
  }

  previewFoto(f: any) {
    this.previewUrl = f.url;
    this.previewDialog = true;
  }

  close() {
    this.dialog = false;
  }
}
